// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-right[data-v-720edc17]{text-align:right}.clock[data-v-720edc17]{font-size:22px;font-weight:500}.green-dot[data-v-720edc17]{display:inline-block;width:8px;height:8px;background-color:#22c55e;border-radius:50%}", ""]);
// Exports
module.exports = exports;
